import React from "react";
import { SvgIcon } from "@mui/material";

import {
  Col,
  Row,
  useUserSelector,
  UserSelectors,
} from "@securitas/react-common-components";
import { Configuration } from "../configuration";
import { AppTile } from "./AppTile";

import {
  AppBody,
  AppRoot,
  AppTopbar,
} from "@securitas/react-common-components/mui";

const ConnectedHomePage: React.FC = () => {
  const userApps = useUserSelector(UserSelectors.applications);

  if (!userApps) return null;

  return (
    <AppRoot>
      <AppTopbar
        appName={Configuration.appName}
        appLogo={Configuration.appLogo as typeof SvgIcon}
      />
      <AppBody>
        <div className="h-100 d-flex align-items-center justify-content-center">
          <Row className="justify-content-center">
            {userApps.map((app) => (
              <Col key={app.url} xs="auto" className="m-4">
                <AppTile app={app} />
              </Col>
            ))}
          </Row>
        </div>
      </AppBody>
    </AppRoot>
  );
};

export default ConnectedHomePage;
